import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import HandIcon from '@swf/core/assets/icons/hand-icon.svg';

import PanicButtonVegas from '../PanicButtonVegas/PanicButtonVegas';
import Tooltip from '../Tooltip/Tooltip';

import {
  TXTWCL_24_hour_lockout,
  TXTWCL_This_is_a_24_hour_one_click_pa_ELL,
  TXTWCL_You_will_not_be_able_to_revers_ELL_1
} from './SelfExclusionTooltip.messages.json';
import {
  infoContainer,
  selfExclusionTooltip,
  selfExclusionTooltipArrow
} from './SelfExclusionTooltip.scss';

const SelfExclusionTooltip: React.FC = () => (
  <Tooltip
    content={
      <div className={infoContainer}>
        <HandIcon />
        <p>
          <Translation tagName="b" {...TXTWCL_24_hour_lockout} />
        </p>
        <Translation tagName="p" {...TXTWCL_This_is_a_24_hour_one_click_pa_ELL} />
        <Translation tagName="p" {...TXTWCL_You_will_not_be_able_to_revers_ELL_1} />
      </div>
    }
    tooltipClassName={selfExclusionTooltip}
    arrowClassName={selfExclusionTooltipArrow}
  >
    <PanicButtonVegas />
  </Tooltip>
);

export default SelfExclusionTooltip;
